
import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHome, faCalculatorAlt, faEnvelopeOpenText, faMobileAlt  } from '@fortawesome/pro-duotone-svg-icons'

class BottomNav extends Component {
    render() {
        return (
            <div id='bottomnav'>
                {this.props.agent && 
                    <React.Fragment>
                        <NavLink exact to='/' activeClassName="selected">
                            <FontAwesomeIcon icon={faHome} />
                            Home
                        </NavLink>
                        <NavLink to='/propertycalculator' activeClassName="selected">
                            <FontAwesomeIcon icon={faCalculatorAlt} />
                            Calculator
                        </NavLink>
                        <NavLink to='/refer' activeClassName="selected">
                            <FontAwesomeIcon icon={faEnvelopeOpenText} />
                            Refer
                        </NavLink>
                        <NavLink to='/install' activeClassName="selected">
                            <FontAwesomeIcon icon={faMobileAlt} />
                            Install app
                        </NavLink>
                    </React.Fragment>
                }
                {(!this.props.agent) && 
                    <React.Fragment>
                        <NavLink exact to='/' activeClassName="selected">
                            <FontAwesomeIcon icon={faCalculatorAlt} />
                            Calculator
                        </NavLink>
                        <NavLink to='/install' activeClassName="selected">
                            <FontAwesomeIcon icon={faMobileAlt} />
                            Install app
                        </NavLink>
                        <a href="https://www.provestor.co.uk/?utm_source=calculator&utm_medium=referral" target="_blank">
                            <FontAwesomeIcon icon={faHome} />
                            Provestor
                        </a>
                    </React.Fragment>
                }

            
         </div>
        );
      }
}

export default BottomNav;



// WEBPACK FOOTER //
// ./src/components/Layout/BottomNav.jsx